const updateURL = ({ variantID, sellingPlanIdInput }) => {
  const url = new URL(window.location.href);
  url.searchParams.set('variant', variantID);

  if (sellingPlanIdInput && sellingPlanIdInput.value && sellingPlanIdInput.value !== '') {
    url.searchParams.set('selling_plan', sellingPlanIdInput.value);
  } else {
    url.searchParams.delete('selling_plan');
  }

  window.history.replaceState({}, '', url);
};

export default updateURL;
